import { render, staticRenderFns } from "./ConfirmBuildingForm.vue?vue&type=template&id=4ecda225&scoped=true"
import script from "./ConfirmBuildingForm.vue?vue&type=script&lang=js"
export * from "./ConfirmBuildingForm.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBuildingForm.vue?vue&type=style&index=0&id=4ecda225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecda225",
  null
  
)

export default component.exports